import React from 'react';
import AddServiceModal from './AddServiceModal';
import { Divider } from '@chakra-ui/react';

const Services = () => {
  return (
    <div>
      <Divider />
      {/* <ServiceList /> */}
      <AddServiceModal />
    </div>
  );
}

export default Services;
